__turbopack_context__.v({
  "className": "pixelify_sans_627e4723-module__agF5vG__className",
  "variable": "pixelify_sans_627e4723-module__agF5vG__variable",
});
